import { useCallback } from 'react';
import { useMutation } from '@tanstack/react-query';
import { useAPI } from './useAPIs';
import { getFilterPreferencePageByStorageKey, encodeSavedSignalEntries } from '../Preferences/filterPreferencesConfig';

export const useUserPreferences = () => {
  const { apiCall } = useAPI();

  const { mutateAsync, isPending: isSaving } = useMutation({
    mutationFn: (preferences) =>
      apiCall('post', '/api/user/preferences', { preferences }),
  });


  const savePreferencesToApi = useCallback(
    async (preferences) => {
      try {
        await mutateAsync(preferences);
        return true;
      } catch (error) {
        console.warn('Could not save preferences to API (stored locally only):', error);
        return false;
      }
    },
    [mutateAsync],
  );

  return { savePreferencesToApi, isSaving };
};


export const hydrateLocalStorageFromApi = (preferences) => {
  if (!preferences || typeof preferences !== 'object') return;

  Object.entries(preferences).forEach(([storageKey, value]) => {
    try {
      if (value === null || value === undefined) {
        localStorage.removeItem(storageKey);
        return;
      }

      const page = getFilterPreferencePageByStorageKey(storageKey);
      if (page?.storageMode === 'signal-list') {
        if (typeof value === 'string') {
          if (value) {
            localStorage.setItem(storageKey, value);
          } else {
            localStorage.removeItem(storageKey);
          }
        } else if (Array.isArray(value) && value.length > 0) {
          const encoded = encodeSavedSignalEntries(value);
          if (encoded) {
            localStorage.setItem(storageKey, encoded);
          } else {
            localStorage.removeItem(storageKey);
          }
        } else {
          localStorage.removeItem(storageKey);
        }
        return;
      }

      if (typeof value === 'string') {
        localStorage.setItem(storageKey, value);
      } else {
        localStorage.setItem(storageKey, JSON.stringify(value));
      }
    } catch (e) {
      console.error(`hydrateLocalStorageFromApi: failed for key "${storageKey}"`, e);
    }
  });

  window.dispatchEvent(new Event('localStorageChange'));
};
